export default __webpack_public_path__ + "static/media/me.bcc0f436.svg";